// extracted by mini-css-extract-plugin
export default {"iconWrapper":"_2XH6l","icon":"_496XX"};